/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { responsesPartMeta } from '../models/responsesPartMeta';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class CompaniesProcessesService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * retrieve a list of Hire data keys
   * @param companyUuid company UUID
   * @param keyType the type of data to be stored by the DataKey
   * @param perPage max number of items to return
   * @param page when set, returns a single page of results (1-based) with server-side paging. Omit for the full unpaged list.
   * @param search case-insensitive substring match on the data key. Applied in paged mode only.
   * @param attributeType restricts keys to those compatible with a WX custom attribute type (string, select, media, ...). Applied in paged mode only.
   * @returns any status success
   * @throws ApiError
   */
  public getApiServiceorganizationsProcessesCompaniesDataKeys(
    companyUuid: string,
    keyType: string = '',
    perPage: string = '1000',
    page?: string,
    search?: string,
    attributeType?: string,
  ): CancelablePromise<{
    data?: Array<{
      /**
       * The DataKey key.
       */
      key: string;
      /**
       * The type of data to be stored by the DataKey
       */
      key_type: string;
      /**
       * The human-readable title of a DataKey
       */
      title: string;
      /**
       * Indicator for whether DataKey is visible
       */
      hidden: boolean;
      /**
       * Indicator for whether DataKey is privileged
       */
      restricted: boolean;
      /**
       * The number of data_fields attached to applicants.
       */
      data_fields_count: number;
      options?: Array<{
        /**
         * The value persisted for the option
         */
        value: string;
        /**
         * The human-readable value for the option
         */
        label?: string;
      }>;
    }>;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/processes/companies/{companyUuid}/dataKeys',
      path: {
        'companyUuid': companyUuid,
      },
      query: {
        'key_type': keyType,
        'per_page': perPage,
        'page': page,
        'search': search,
        'attribute_type': attributeType,
      },
    });
  }

  /**
   * retrieve a list of Hire embedded signature templates
   * @param companyUuid company UUID
   * @returns any status success
   * @throws ApiError
   */
  public getApiServiceorganizationsProcessesCompaniesEmbeddedSignatureTemplates(
    companyUuid: string,
  ): CancelablePromise<{
    data?: Array<{
      /**
       * The embedded signature template ID.
       */
      template_id: string;
      /**
       * The title of the embedded signature template.
       */
      title: string;
      /**
       * The provider of the embedded signature template.
       */
      provider: string;
    }>;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/processes/companies/{companyUuid}/embeddedSignatureTemplates',
      path: {
        'companyUuid': companyUuid,
      },
    });
  }

  /**
   * get WX companies by Hire account UUID
   * @param hireAccountUuid hire account UUID
   * @returns any status success
   * @throws ApiError
   */
  public getApiServiceorganizationsProcessesCompaniesHire(
    hireAccountUuid: string,
  ): CancelablePromise<{
    data?: Array<{
      hireAccountUuid?: string;
      hireAccountBaseUrl?: string;
      hireAccountApiKey?: string;
      hireAccountSlug?: string;
      unifiedAuth?: boolean;
      tfaRequired?: boolean;
      inactivityLockDays?: number;
      hasHireGoAccount?: boolean;
      brand?: {
        websiteUrl?: string;
      };
    }>;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/processes/companies/hire/{hireAccountUuid}',
      path: {
        'hireAccountUuid': hireAccountUuid,
      },
    });
  }

  /**
   * retrieve a list of Hire openings
   * @param companyUuid company UUID
   * @param page The page of entities to retrieve
   * @param search Name of the location to search
   * @returns any status success
   * @throws ApiError
   */
  public getApiServiceorganizationsProcessesCompaniesOpenings(
    companyUuid: string,
    page?: number,
    search?: string,
  ): CancelablePromise<{
    data?: {
      openings?: Array<{
        title?: string;
        description?: string;
        apply_url: string;
        id: string;
        address: string;
        time_zone: string;
        requirements?: string;
        is_private: boolean;
        active: boolean;
        custom_id?: string | null;
        force_applicant_identity?: boolean | null;
        created_at: string;
        additional_info?: string | null;
        application_deadline?: string | null;
        brand?: string | null;
        opening_pay_rate?: {
          compensation: string;
          compensation_currency_code: string;
          compensation_type: 'hour' | 'day' | 'month' | 'year';
        } | null;
        job_hours?: 'full_time' | 'part_time' | null;
        job_type?: 'permanent' | 'temporary' | 'contract_freelancer' | 'casual' | 'finance_plus_accounting' | 'operations_leadership' | 'all_other_administrative_plus_professional' | 'information_technology' | 'customer_service_plus_operations' | 'local' | 'regional' | 'trainee' | null;
        job_industry?: 'accounting' | 'agriculture' | 'audio_visual' | 'automotive' | 'banking_and_finance' | 'construction' | 'consultancy' | 'customer_service_and_call_centres' | 'dental' | 'education_and_training' | 'electronics' | 'energy_oil_and_gas' | 'engineering' | 'environmental_and_waste' | 'facilities_management' | 'food_hospitality' | 'hair_beauty_and_cosmetics' | 'health_medical_and_related' | 'human_resources' | 'insurance' | 'it_and_internet' | 'legal' | 'logistics_procurement_distribution_and_supply_chain' | 'manufacturing_and_production' | 'marketing_advertising_and_pr' | 'media_new_media_and_creative' | 'military_and_defence' | 'mining' | 'nonprofit' | 'other' | 'property_and_real-estate' | 'recruitment' | 'retail' | 'sales' | 'scientific_and_pharmaceuticals' | 'secretarial_and_administration' | 'telecommunications' | 'training' | 'travel_leisure_and_tourism' | 'transportation' | 'web_html_info_design' | 'writing_editing' | null;
        workflow_id?: string | null;
        is_hiring_funnel: boolean;
        is_sourcing_funnel: boolean;
        alternative_locales?: Array<string>;
        customer_attributes?: Array<{
          value: string;
          type: string;
        }> | null;
        stages: Array<{
          title: string;
          type: string;
          parent_id?: string;
          id: string;
          data_fields?: Array<{
            key: string;
            type: string;
            question: string;
            storage: 'data' | 'secure_data' | 'applicant';
            options?: Array<{
              value?: string;
              label?: string;
            }>;
          }>;
        }>;
        fields?: Array<{
          question: string;
          type: string;
          key: string;
        }>;
        location: {
          name: string;
          id: string;
          latitude?: number;
          longitude?: number;
          customer_attributes?: Array<{
            value: string;
            type: string;
          }>;
          location_group: {
            name: string;
            id: string;
            customer_attributes?: Array<{
              value: string;
              type: string;
            }>;
          };
        };
        owner: {
          name: string;
          id: string;
          email: string;
        };
        position: {
          name: string;
          id: string;
          customer_attributes?: Array<{
            value: string;
            type: string;
          }>;
        };
        shift?: {
          name?: string;
          id: string;
          description?: string;
          days_of_week: 'mon' | 'tue' | 'wed' | 'thu' | 'fri' | 'sat' | 'sun';
          hours: {
            start_time?: number;
            end_time?: number;
          };
          customer_attributes?: Array<{
            value: string;
            type: string;
          }>;
        };
      }>;
      pagination?: {
        first?: number;
        last?: number;
        previous?: number | null;
        current?: number;
        next?: number | null;
      };
    };
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/processes/companies/{companyUuid}/openings',
      path: {
        'companyUuid': companyUuid,
      },
      query: {
        'page': page,
        'search': search,
      },
    });
  }

  /**
   * retrieve a list of Hire positions
   * @param companyUuid company UUID
   * @param brandUuid brand UUID
   * @returns any status success
   * @throws ApiError
   */
  public getApiServiceorganizationsProcessesCompaniesPositions(
    companyUuid: string,
    brandUuid?: string,
  ): CancelablePromise<{
    data?: {
      positions?: Array<{
        name: string;
        id: string;
        account_id: string;
        short_description?: string;
      }>;
    };
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/processes/companies/{companyUuid}/positions',
      path: {
        'companyUuid': companyUuid,
      },
      query: {
        'brandUuid': brandUuid,
      },
    });
  }

  /**
   * retrieve a list of Hire locations
   * @param companyUuid company UUID
   * @param brandUuid brand UUID
   * @returns any status success
   * @throws ApiError
   */
  public getApiServiceorganizationsProcessesCompaniesLocations(
    companyUuid: string,
    brandUuid?: string,
  ): CancelablePromise<{
    data?: {
      locations?: Array<{
        name: string;
        id: string;
        account_id: string;
        address?: string;
        street_address?: string;
        city?: string;
        state_code?: string;
        postal_code?: string;
        country_code?: string;
        location_group: {
          name: string;
          id: string;
          owner: string;
        };
      }>;
    };
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/processes/companies/{companyUuid}/locations',
      path: {
        'companyUuid': companyUuid,
      },
      query: {
        'brandUuid': brandUuid,
      },
    });
  }

  /**
   * Retrieve company for the authenticated user
   * @returns any status success
   * @throws ApiError
   */
  public getApiServiceorganizationsProcessesMcpCompanies(): CancelablePromise<{
    data?: {
      readonly uuid?: string;
      readonly createdAt?: string;
      readonly createdBy?: string;
      readonly lastUpdatedAt?: string;
      readonly lastUpdatedBy?: string;
      readonly lastUpdatedByAudience?: string;
      readonly lastUpdatedByAudienceUuid?: string;
      readonly lastUpdatedByImpersonatedBy?: string;
      readonly lastUpdatedByCompanyUuid?: string;
      readonly lastUpdatedByEnterpriseUuid?: string;
      name: string;
      slug?: string;
      mainLogoUrl?: string;
      mainWebsiteUrl?: string;
      privacyPolicyUrl?: string;
      termsOfServiceUrl?: string;
      defaultBrandUuid?: string;
      address?: {
        address1?: string;
        address2?: string;
        city?: string;
        zip?: string;
        state?: string;
        country?: string;
      };
      /**
       * whether the portal has been configured at least once
       */
      hasSetupPortal?: boolean;
      /**
       * Optional metadata object containing self-serve account information and other additional fields.
       */
      metadata?: Record<string, any>;
      legalName?: string;
      /**
       * Employer identification number
       */
      ein?: string;
      /**
       * when the hire account was connected
       */
      readonly hireConnectedAt?: string | null;
      /**
       * Account UUID in Fountain Hire
       */
      hireAccountUuid?: string;
      /**
       * Account base URL in Fountain Hire
       */
      hireAccountBaseUrl?: string;
      /**
       * Account base URL for Fountain Go
       */
      hireGoAccountBaseUrl?: string;
      /**
       * Account Career Site base URL in Fountain Hire
       */
      careerSiteUrl?: string;
      /**
       * Account API key in Fountain Hire
       */
      hireAccountApiKey?: string;
      /**
       * Account Recruiter Base URL in Fountain Hire
       */
      hireAccountRecruiterBaseUrl?: string;
      /**
       * Account slug in Fountain Hire
       */
      hireAccountSlug?: string;
      /**
       * Contact email for workers needing additional assistance
       */
      supportEmail?: string;
      /**
       * Contact phone number for workers needing additional assistance
       */
      supportPhone?: string;
      /**
       * Customer-facing support URL
       */
      supportUrl?: string;
      /**
       * Email of the authorized representative for SMS brand registration
       */
      contactEmail?: string;
      /**
       * Phone number of the authorized representative for SMS brand registration
       */
      contactPhone?: string;
      /**
       * Alternative phone numbers for workers according to their hiring source
       */
      alternativeSupportPhones?: Array<{
        number: string;
        source: string;
      }>;
      /**
       * Enables or disables employer messaging functionality for Hire applicants
       */
      hireMessagingEnabled?: boolean;
      /**
       * Enables or disables employer messaging functionality for Workday candidates
       */
      workdayMessagingEnabled?: boolean;
      /**
       * Enables or disables automated data synchronization with Fountain Hire
       */
      enableHireDataSync?: boolean;
      /**
       * This company has a Fountain Hire Go account
       */
      hasHireGoAccount?: boolean;
      /**
       * This company uses unified authentication system
       */
      unifiedAuth?: boolean;
      /**
       * This company uses unified access system
       */
      unifiedAccess?: boolean;
      /**
       * If true, all users in this company need 2fa enabled
       */
      tfaRequired?: boolean;
      /**
       * Number of days before a worker is considered inactive and locked out of the system
       */
      inactivityLockDays?: number;
      /**
       * Password policy for employers in the company
       */
      passwordPolicy?: {
        /**
         * Minimum length of the password
         */
        minLength?: number;
        /**
         * Number of days before the password expires
         */
        expireAfterDays?: number;
      };
      portalOptions?: {
        enableMagicLink?: boolean;
        enableOtp?: boolean;
        enableUpdateContactInfo?: {
          firstname?: boolean;
          lastname?: boolean;
          personalEmail?: boolean;
          mobilePhone?: boolean;
        };
        enableSmsOptOut?: boolean;
      };
      companyType?: 'active' | 'internal' | 'pilot' | 'demo';
      /**
       * Lifecycle status mirrored from the Hire account. Only settable via the internal process endpoint.
       */
      accountStatus?: 'live' | 'paused' | 'churned';
      /**
       * Contact first name for SMS brand registration
       */
      contactFirstName?: string;
      /**
       * Contact last name for SMS brand registration
       */
      contactLastName?: string;
      /**
       * Industry vertical for SMS brand registration
       */
      vertical?: 'AGRICULTURE' | 'COMMUNICATION' | 'CONSTRUCTION' | 'EDUCATION' | 'ENERGY' | 'ENTERTAINMENT' | 'FINANCIAL' | 'GAMBLING' | 'GOVERNMENT' | 'HEALTHCARE' | 'HOSPITALITY' | 'HUMAN_RESOURCES' | 'INSURANCE' | 'LEGAL' | 'MANUFACTURING' | 'NGO' | 'POLITICAL' | 'POSTAL' | 'PROFESSIONAL' | 'REAL_ESTATE' | 'RETAIL' | 'TECHNOLOGY' | 'TRANSPORTATION';
      /**
       * Salesforce ID for the company
       */
      salesforceId?: string;
      /**
       * Indicates if this company was created through self-serve registration
       */
      selfServe?: boolean;
      /**
       * Free-form context notes about the company.
       */
      companyContext?: string;
      /**
       * IANA timezone identifier for the company (e.g. "America/Chicago"). Used to determine business hours for outbound worker actions.
       */
      timezone?: 'Pacific/Niue' | 'Pacific/Pago_Pago' | 'Pacific/Honolulu' | 'Pacific/Rarotonga' | 'Pacific/Tahiti' | 'Pacific/Marquesas' | 'America/Anchorage' | 'Pacific/Gambier' | 'America/Los_Angeles' | 'America/Tijuana' | 'America/Vancouver' | 'America/Whitehorse' | 'Pacific/Pitcairn' | 'America/Dawson_Creek' | 'America/Denver' | 'America/Edmonton' | 'America/Hermosillo' | 'America/Mazatlan' | 'America/Phoenix' | 'America/Yellowknife' | 'America/Belize' | 'America/Chicago' | 'America/Costa_Rica' | 'America/El_Salvador' | 'America/Guatemala' | 'America/Managua' | 'America/Mexico_City' | 'America/Regina' | 'America/Tegucigalpa' | 'America/Winnipeg' | 'Pacific/Galapagos' | 'America/Bogota' | 'America/Cancun' | 'America/Cayman' | 'America/Guayaquil' | 'America/Havana' | 'America/Iqaluit' | 'America/Jamaica' | 'America/Lima' | 'America/Nassau' | 'America/New_York' | 'America/Panama' | 'America/Port-au-Prince' | 'America/Rio_Branco' | 'America/Toronto' | 'Pacific/Easter' | 'America/Caracas' | 'America/Asuncion' | 'America/Barbados' | 'America/Boa_Vista' | 'America/Campo_Grande' | 'America/Cuiaba' | 'America/Curacao' | 'America/Grand_Turk' | 'America/Guyana' | 'America/Halifax' | 'America/La_Paz' | 'America/Manaus' | 'America/Martinique' | 'America/Port_of_Spain' | 'America/Porto_Velho' | 'America/Puerto_Rico' | 'America/Santo_Domingo' | 'America/Thule' | 'Atlantic/Bermuda' | 'America/St_Johns' | 'America/Araguaina' | 'America/Argentina/Buenos_Aires' | 'America/Bahia' | 'America/Belem' | 'America/Cayenne' | 'America/Fortaleza' | 'America/Godthab' | 'America/Maceio' | 'America/Miquelon' | 'America/Montevideo' | 'America/Paramaribo' | 'America/Recife' | 'America/Santiago' | 'America/Sao_Paulo' | 'Antarctica/Palmer' | 'Antarctica/Rothera' | 'Atlantic/Stanley' | 'America/Noronha' | 'Atlantic/South_Georgia' | 'America/Scoresbysund' | 'Atlantic/Azores' | 'Atlantic/Cape_Verde' | 'Africa/Abidjan' | 'Africa/Accra' | 'Africa/Bissau' | 'Africa/Casablanca' | 'Africa/El_Aaiun' | 'Africa/Monrovia' | 'America/Danmarkshavn' | 'Atlantic/Canary' | 'Atlantic/Faroe' | 'Atlantic/Reykjavik' | 'Etc/GMT' | 'Europe/Dublin' | 'Europe/Lisbon' | 'Europe/London' | 'Africa/Algiers' | 'Africa/Ceuta' | 'Africa/Lagos' | 'Africa/Ndjamena' | 'Africa/Tunis' | 'Africa/Windhoek' | 'Europe/Amsterdam' | 'Europe/Andorra' | 'Europe/Belgrade' | 'Europe/Berlin' | 'Europe/Brussels' | 'Europe/Budapest' | 'Europe/Copenhagen' | 'Europe/Gibraltar' | 'Europe/Ljubljana' | 'Europe/Luxembourg' | 'Europe/Madrid' | 'Europe/Malta' | 'Europe/Monaco' | 'Europe/Oslo' | 'Europe/Paris' | 'Europe/Prague' | 'Europe/Rome' | 'Europe/Stockholm' | 'Europe/Tirane' | 'Europe/Vienna' | 'Europe/Warsaw' | 'Europe/Zurich' | 'Africa/Cairo' | 'Africa/Johannesburg' | 'Africa/Maputo' | 'Africa/Tripoli' | 'Asia/Amman' | 'Asia/Beirut' | 'Asia/Damascus' | 'Asia/Gaza' | 'Asia/Jerusalem' | 'Asia/Nicosia' | 'Europe/Athens' | 'Europe/Bucharest' | 'Europe/Chisinau' | 'Europe/Helsinki' | 'Europe/Istanbul' | 'Europe/Kaliningrad' | 'Europe/Kyiv' | 'Europe/Riga' | 'Europe/Sofia' | 'Europe/Tallinn' | 'Europe/Vilnius' | 'Africa/Khartoum' | 'Africa/Nairobi' | 'Antarctica/Syowa' | 'Asia/Baghdad' | 'Asia/Qatar' | 'Asia/Riyadh' | 'Europe/Minsk' | 'Europe/Moscow' | 'Asia/Tehran' | 'Asia/Baku' | 'Asia/Dubai' | 'Asia/Tbilisi' | 'Asia/Yerevan' | 'Europe/Samara' | 'Indian/Mahe' | 'Indian/Mauritius' | 'Indian/Reunion' | 'Asia/Kabul' | 'Antarctica/Mawson' | 'Asia/Aqtau' | 'Asia/Aqtobe' | 'Asia/Ashgabat' | 'Asia/Dushanbe' | 'Asia/Karachi' | 'Asia/Tashkent' | 'Asia/Yekaterinburg' | 'Indian/Kerguelen' | 'Indian/Maldives' | 'Asia/Calcutta' | 'Asia/Colombo' | 'Asia/Katmandu' | 'Antarctica/Vostok' | 'Asia/Almaty' | 'Asia/Bishkek' | 'Asia/Dhaka' | 'Asia/Omsk' | 'Asia/Thimphu' | 'Indian/Chagos' | 'Asia/Rangoon' | 'Indian/Cocos' | 'Antarctica/Davis' | 'Asia/Bangkok' | 'Asia/Hovd' | 'Asia/Jakarta' | 'Asia/Krasnoyarsk' | 'Asia/Saigon' | 'Asia/Ho_Chi_Minh' | 'Indian/Christmas' | 'Antarctica/Casey' | 'Asia/Brunei' | 'Asia/Choibalsan' | 'Asia/Hong_Kong' | 'Asia/Irkutsk' | 'Asia/Kuala_Lumpur' | 'Asia/Macau' | 'Asia/Makassar' | 'Asia/Manila' | 'Asia/Shanghai' | 'Asia/Singapore' | 'Asia/Taipei' | 'Asia/Ulaanbaatar' | 'Australia/Perth' | 'Asia/Pyongyang' | 'Asia/Dili' | 'Asia/Jayapura' | 'Asia/Seoul' | 'Asia/Tokyo' | 'Asia/Yakutsk' | 'Pacific/Palau' | 'Australia/Adelaide' | 'Australia/Darwin' | 'Antarctica/DumontDUrville' | 'Asia/Magadan' | 'Asia/Vladivostok' | 'Australia/Brisbane' | 'Asia/Sakhalin' | 'Australia/Hobart' | 'Australia/Sydney' | 'Pacific/Chuuk' | 'Pacific/Guam' | 'Pacific/Port_Moresby' | 'Pacific/Efate' | 'Pacific/Guadalcanal' | 'Pacific/Kosrae' | 'Pacific/Norfolk' | 'Pacific/Noumea' | 'Pacific/Pohnpei' | 'Asia/Kamchatka' | 'Pacific/Auckland' | 'Pacific/Fiji' | 'Pacific/Funafuti' | 'Pacific/Kwajalein' | 'Pacific/Majuro' | 'Pacific/Nauru' | 'Pacific/Tarawa' | 'Pacific/Wake' | 'Pacific/Wallis' | 'Pacific/Apia' | 'Pacific/Enderbury' | 'Pacific/Fakaofo' | 'Pacific/Tongatapu' | 'Pacific/Kiritimati' | 'UTC';
      /**
       * Per-product freemium access flags (internal only)
       */
      freemiumProducts?: {
        pool?: {
          /**
           * Whether Pool freemium is enabled for this company
           */
          enabled?: boolean;
        };
      };
    };
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/processes/mcp/companies',
    });
  }

  /**
   * Update user-editable fields on the current company
   * @param requestBody
   * @returns any Successfully updated company
   * @throws ApiError
   */
  public patchApiServiceorganizationsProcessesMcpCompanies(
    requestBody: {
      /**
       * Display name of the company.
       */
      name?: string;
      /**
       * Company address information.
       */
      address?: {
        /**
         * Primary address line.
         */
        address1?: string;
        /**
         * Secondary address line.
         */
        address2?: string;
        /**
         * City name.
         */
        city?: string;
        /**
         * ZIP or postal code.
         */
        zip?: string;
        /**
         * State or province name.
         */
        state?: string;
        /**
         * Country name.
         */
        country?: string;
      };
      /**
       * URL to the company logo.
       */
      mainLogoUrl?: string;
      /**
       * URL to the company website. Used as the "website" field in Bird brand registration.
       */
      mainWebsiteUrl?: string;
      /**
       * URL to the company privacy policy page. Used as the "privacy_policy_url" field in Bird brand registration.
       */
      privacyPolicyUrl?: string;
      /**
       * URL to the company terms of service page. Used as the "terms_of_service_url" field in Bird brand registration.
       */
      termsOfServiceUrl?: string;
      /**
       * Email of the authorized representative for SMS brand registration. Used as the "email" field in Bird brand registration.
       */
      contactEmail?: string;
      /**
       * Contact first name for SMS brand registration. Used as the "first_name" field in Bird brand registration.
       */
      contactFirstName?: string;
      /**
       * Contact last name for SMS brand registration. Used as the "last_name" field in Bird brand registration.
       */
      contactLastName?: string;
      /**
       * Phone number of the authorized representative for SMS brand registration. Used as the "phone" field in Bird brand registration.
       */
      contactPhone?: string;
      /**
       * URL for customer support resources (e.g. a contact page or help center).
       */
      supportUrl?: string;
      /**
       * Customer-facing support email address.
       */
      supportEmail?: string;
      /**
       * Customer-facing support phone number in E.164 format. Used as the contact number in SMS campaign help messages.
       */
      supportPhone?: string;
      /**
       * Industry vertical for SMS brand registration. Used as the "vertical" field in Bird brand registration.
       */
      vertical?: 'AGRICULTURE' | 'COMMUNICATION' | 'CONSTRUCTION' | 'EDUCATION' | 'ENERGY' | 'ENTERTAINMENT' | 'FINANCIAL' | 'GAMBLING' | 'GOVERNMENT' | 'HEALTHCARE' | 'HOSPITALITY' | 'HUMAN_RESOURCES' | 'INSURANCE' | 'LEGAL' | 'MANUFACTURING' | 'NGO' | 'POLITICAL' | 'POSTAL' | 'PROFESSIONAL' | 'REAL_ESTATE' | 'RETAIL' | 'TECHNOLOGY' | 'TRANSPORTATION';
      /**
       * Preferred office timezone used for business-hours scheduling.
       */
      timezone?: 'Pacific/Niue' | 'Pacific/Pago_Pago' | 'Pacific/Honolulu' | 'Pacific/Rarotonga' | 'Pacific/Tahiti' | 'Pacific/Marquesas' | 'America/Anchorage' | 'Pacific/Gambier' | 'America/Los_Angeles' | 'America/Tijuana' | 'America/Vancouver' | 'America/Whitehorse' | 'Pacific/Pitcairn' | 'America/Dawson_Creek' | 'America/Denver' | 'America/Edmonton' | 'America/Hermosillo' | 'America/Mazatlan' | 'America/Phoenix' | 'America/Yellowknife' | 'America/Belize' | 'America/Chicago' | 'America/Costa_Rica' | 'America/El_Salvador' | 'America/Guatemala' | 'America/Managua' | 'America/Mexico_City' | 'America/Regina' | 'America/Tegucigalpa' | 'America/Winnipeg' | 'Pacific/Galapagos' | 'America/Bogota' | 'America/Cancun' | 'America/Cayman' | 'America/Guayaquil' | 'America/Havana' | 'America/Iqaluit' | 'America/Jamaica' | 'America/Lima' | 'America/Nassau' | 'America/New_York' | 'America/Panama' | 'America/Port-au-Prince' | 'America/Rio_Branco' | 'America/Toronto' | 'Pacific/Easter' | 'America/Caracas' | 'America/Asuncion' | 'America/Barbados' | 'America/Boa_Vista' | 'America/Campo_Grande' | 'America/Cuiaba' | 'America/Curacao' | 'America/Grand_Turk' | 'America/Guyana' | 'America/Halifax' | 'America/La_Paz' | 'America/Manaus' | 'America/Martinique' | 'America/Port_of_Spain' | 'America/Porto_Velho' | 'America/Puerto_Rico' | 'America/Santo_Domingo' | 'America/Thule' | 'Atlantic/Bermuda' | 'America/St_Johns' | 'America/Araguaina' | 'America/Argentina/Buenos_Aires' | 'America/Bahia' | 'America/Belem' | 'America/Cayenne' | 'America/Fortaleza' | 'America/Godthab' | 'America/Maceio' | 'America/Miquelon' | 'America/Montevideo' | 'America/Paramaribo' | 'America/Recife' | 'America/Santiago' | 'America/Sao_Paulo' | 'Antarctica/Palmer' | 'Antarctica/Rothera' | 'Atlantic/Stanley' | 'America/Noronha' | 'Atlantic/South_Georgia' | 'America/Scoresbysund' | 'Atlantic/Azores' | 'Atlantic/Cape_Verde' | 'Africa/Abidjan' | 'Africa/Accra' | 'Africa/Bissau' | 'Africa/Casablanca' | 'Africa/El_Aaiun' | 'Africa/Monrovia' | 'America/Danmarkshavn' | 'Atlantic/Canary' | 'Atlantic/Faroe' | 'Atlantic/Reykjavik' | 'Etc/GMT' | 'Europe/Dublin' | 'Europe/Lisbon' | 'Europe/London' | 'Africa/Algiers' | 'Africa/Ceuta' | 'Africa/Lagos' | 'Africa/Ndjamena' | 'Africa/Tunis' | 'Africa/Windhoek' | 'Europe/Amsterdam' | 'Europe/Andorra' | 'Europe/Belgrade' | 'Europe/Berlin' | 'Europe/Brussels' | 'Europe/Budapest' | 'Europe/Copenhagen' | 'Europe/Gibraltar' | 'Europe/Ljubljana' | 'Europe/Luxembourg' | 'Europe/Madrid' | 'Europe/Malta' | 'Europe/Monaco' | 'Europe/Oslo' | 'Europe/Paris' | 'Europe/Prague' | 'Europe/Rome' | 'Europe/Stockholm' | 'Europe/Tirane' | 'Europe/Vienna' | 'Europe/Warsaw' | 'Europe/Zurich' | 'Africa/Cairo' | 'Africa/Johannesburg' | 'Africa/Maputo' | 'Africa/Tripoli' | 'Asia/Amman' | 'Asia/Beirut' | 'Asia/Damascus' | 'Asia/Gaza' | 'Asia/Jerusalem' | 'Asia/Nicosia' | 'Europe/Athens' | 'Europe/Bucharest' | 'Europe/Chisinau' | 'Europe/Helsinki' | 'Europe/Istanbul' | 'Europe/Kaliningrad' | 'Europe/Kyiv' | 'Europe/Riga' | 'Europe/Sofia' | 'Europe/Tallinn' | 'Europe/Vilnius' | 'Africa/Khartoum' | 'Africa/Nairobi' | 'Antarctica/Syowa' | 'Asia/Baghdad' | 'Asia/Qatar' | 'Asia/Riyadh' | 'Europe/Minsk' | 'Europe/Moscow' | 'Asia/Tehran' | 'Asia/Baku' | 'Asia/Dubai' | 'Asia/Tbilisi' | 'Asia/Yerevan' | 'Europe/Samara' | 'Indian/Mahe' | 'Indian/Mauritius' | 'Indian/Reunion' | 'Asia/Kabul' | 'Antarctica/Mawson' | 'Asia/Aqtau' | 'Asia/Aqtobe' | 'Asia/Ashgabat' | 'Asia/Dushanbe' | 'Asia/Karachi' | 'Asia/Tashkent' | 'Asia/Yekaterinburg' | 'Indian/Kerguelen' | 'Indian/Maldives' | 'Asia/Calcutta' | 'Asia/Colombo' | 'Asia/Katmandu' | 'Antarctica/Vostok' | 'Asia/Almaty' | 'Asia/Bishkek' | 'Asia/Dhaka' | 'Asia/Omsk' | 'Asia/Thimphu' | 'Indian/Chagos' | 'Asia/Rangoon' | 'Indian/Cocos' | 'Antarctica/Davis' | 'Asia/Bangkok' | 'Asia/Hovd' | 'Asia/Jakarta' | 'Asia/Krasnoyarsk' | 'Asia/Saigon' | 'Asia/Ho_Chi_Minh' | 'Indian/Christmas' | 'Antarctica/Casey' | 'Asia/Brunei' | 'Asia/Choibalsan' | 'Asia/Hong_Kong' | 'Asia/Irkutsk' | 'Asia/Kuala_Lumpur' | 'Asia/Macau' | 'Asia/Makassar' | 'Asia/Manila' | 'Asia/Shanghai' | 'Asia/Singapore' | 'Asia/Taipei' | 'Asia/Ulaanbaatar' | 'Australia/Perth' | 'Asia/Pyongyang' | 'Asia/Dili' | 'Asia/Jayapura' | 'Asia/Seoul' | 'Asia/Tokyo' | 'Asia/Yakutsk' | 'Pacific/Palau' | 'Australia/Adelaide' | 'Australia/Darwin' | 'Antarctica/DumontDUrville' | 'Asia/Magadan' | 'Asia/Vladivostok' | 'Australia/Brisbane' | 'Asia/Sakhalin' | 'Australia/Hobart' | 'Australia/Sydney' | 'Pacific/Chuuk' | 'Pacific/Guam' | 'Pacific/Port_Moresby' | 'Pacific/Efate' | 'Pacific/Guadalcanal' | 'Pacific/Kosrae' | 'Pacific/Norfolk' | 'Pacific/Noumea' | 'Pacific/Pohnpei' | 'Asia/Kamchatka' | 'Pacific/Auckland' | 'Pacific/Fiji' | 'Pacific/Funafuti' | 'Pacific/Kwajalein' | 'Pacific/Majuro' | 'Pacific/Nauru' | 'Pacific/Tarawa' | 'Pacific/Wake' | 'Pacific/Wallis' | 'Pacific/Apia' | 'Pacific/Enderbury' | 'Pacific/Fakaofo' | 'Pacific/Tongatapu' | 'Pacific/Kiritimati' | 'UTC';
    },
  ): CancelablePromise<{
    readonly uuid?: string;
    readonly createdAt?: string;
    readonly createdBy?: string;
    readonly lastUpdatedAt?: string;
    readonly lastUpdatedBy?: string;
    readonly lastUpdatedByAudience?: string;
    readonly lastUpdatedByAudienceUuid?: string;
    readonly lastUpdatedByImpersonatedBy?: string;
    readonly lastUpdatedByCompanyUuid?: string;
    readonly lastUpdatedByEnterpriseUuid?: string;
    name: string;
    slug?: string;
    mainLogoUrl?: string;
    mainWebsiteUrl?: string;
    privacyPolicyUrl?: string;
    termsOfServiceUrl?: string;
    defaultBrandUuid?: string;
    address?: {
      address1?: string;
      address2?: string;
      city?: string;
      zip?: string;
      state?: string;
      country?: string;
    };
    /**
     * whether the portal has been configured at least once
     */
    hasSetupPortal?: boolean;
    /**
     * Optional metadata object containing self-serve account information and other additional fields.
     */
    metadata?: Record<string, any>;
    legalName?: string;
    /**
     * Employer identification number
     */
    ein?: string;
    /**
     * when the hire account was connected
     */
    readonly hireConnectedAt?: string | null;
    /**
     * Account UUID in Fountain Hire
     */
    hireAccountUuid?: string;
    /**
     * Account base URL in Fountain Hire
     */
    hireAccountBaseUrl?: string;
    /**
     * Account base URL for Fountain Go
     */
    hireGoAccountBaseUrl?: string;
    /**
     * Account Career Site base URL in Fountain Hire
     */
    careerSiteUrl?: string;
    /**
     * Account API key in Fountain Hire
     */
    hireAccountApiKey?: string;
    /**
     * Account Recruiter Base URL in Fountain Hire
     */
    hireAccountRecruiterBaseUrl?: string;
    /**
     * Account slug in Fountain Hire
     */
    hireAccountSlug?: string;
    /**
     * Contact email for workers needing additional assistance
     */
    supportEmail?: string;
    /**
     * Contact phone number for workers needing additional assistance
     */
    supportPhone?: string;
    /**
     * Customer-facing support URL
     */
    supportUrl?: string;
    /**
     * Email of the authorized representative for SMS brand registration
     */
    contactEmail?: string;
    /**
     * Phone number of the authorized representative for SMS brand registration
     */
    contactPhone?: string;
    /**
     * Alternative phone numbers for workers according to their hiring source
     */
    alternativeSupportPhones?: Array<{
      number: string;
      source: string;
    }>;
    /**
     * Enables or disables employer messaging functionality for Hire applicants
     */
    hireMessagingEnabled?: boolean;
    /**
     * Enables or disables employer messaging functionality for Workday candidates
     */
    workdayMessagingEnabled?: boolean;
    /**
     * Enables or disables automated data synchronization with Fountain Hire
     */
    enableHireDataSync?: boolean;
    /**
     * This company has a Fountain Hire Go account
     */
    hasHireGoAccount?: boolean;
    /**
     * This company uses unified authentication system
     */
    unifiedAuth?: boolean;
    /**
     * This company uses unified access system
     */
    unifiedAccess?: boolean;
    /**
     * If true, all users in this company need 2fa enabled
     */
    tfaRequired?: boolean;
    /**
     * Number of days before a worker is considered inactive and locked out of the system
     */
    inactivityLockDays?: number;
    /**
     * Password policy for employers in the company
     */
    passwordPolicy?: {
      /**
       * Minimum length of the password
       */
      minLength?: number;
      /**
       * Number of days before the password expires
       */
      expireAfterDays?: number;
    };
    portalOptions?: {
      enableMagicLink?: boolean;
      enableOtp?: boolean;
      enableUpdateContactInfo?: {
        firstname?: boolean;
        lastname?: boolean;
        personalEmail?: boolean;
        mobilePhone?: boolean;
      };
      enableSmsOptOut?: boolean;
    };
    companyType?: 'active' | 'internal' | 'pilot' | 'demo';
    /**
     * Lifecycle status mirrored from the Hire account. Only settable via the internal process endpoint.
     */
    accountStatus?: 'live' | 'paused' | 'churned';
    /**
     * Contact first name for SMS brand registration
     */
    contactFirstName?: string;
    /**
     * Contact last name for SMS brand registration
     */
    contactLastName?: string;
    /**
     * Industry vertical for SMS brand registration
     */
    vertical?: 'AGRICULTURE' | 'COMMUNICATION' | 'CONSTRUCTION' | 'EDUCATION' | 'ENERGY' | 'ENTERTAINMENT' | 'FINANCIAL' | 'GAMBLING' | 'GOVERNMENT' | 'HEALTHCARE' | 'HOSPITALITY' | 'HUMAN_RESOURCES' | 'INSURANCE' | 'LEGAL' | 'MANUFACTURING' | 'NGO' | 'POLITICAL' | 'POSTAL' | 'PROFESSIONAL' | 'REAL_ESTATE' | 'RETAIL' | 'TECHNOLOGY' | 'TRANSPORTATION';
    /**
     * Salesforce ID for the company
     */
    salesforceId?: string;
    /**
     * Indicates if this company was created through self-serve registration
     */
    selfServe?: boolean;
    /**
     * Free-form context notes about the company.
     */
    companyContext?: string;
    /**
     * IANA timezone identifier for the company (e.g. "America/Chicago"). Used to determine business hours for outbound worker actions.
     */
    timezone?: 'Pacific/Niue' | 'Pacific/Pago_Pago' | 'Pacific/Honolulu' | 'Pacific/Rarotonga' | 'Pacific/Tahiti' | 'Pacific/Marquesas' | 'America/Anchorage' | 'Pacific/Gambier' | 'America/Los_Angeles' | 'America/Tijuana' | 'America/Vancouver' | 'America/Whitehorse' | 'Pacific/Pitcairn' | 'America/Dawson_Creek' | 'America/Denver' | 'America/Edmonton' | 'America/Hermosillo' | 'America/Mazatlan' | 'America/Phoenix' | 'America/Yellowknife' | 'America/Belize' | 'America/Chicago' | 'America/Costa_Rica' | 'America/El_Salvador' | 'America/Guatemala' | 'America/Managua' | 'America/Mexico_City' | 'America/Regina' | 'America/Tegucigalpa' | 'America/Winnipeg' | 'Pacific/Galapagos' | 'America/Bogota' | 'America/Cancun' | 'America/Cayman' | 'America/Guayaquil' | 'America/Havana' | 'America/Iqaluit' | 'America/Jamaica' | 'America/Lima' | 'America/Nassau' | 'America/New_York' | 'America/Panama' | 'America/Port-au-Prince' | 'America/Rio_Branco' | 'America/Toronto' | 'Pacific/Easter' | 'America/Caracas' | 'America/Asuncion' | 'America/Barbados' | 'America/Boa_Vista' | 'America/Campo_Grande' | 'America/Cuiaba' | 'America/Curacao' | 'America/Grand_Turk' | 'America/Guyana' | 'America/Halifax' | 'America/La_Paz' | 'America/Manaus' | 'America/Martinique' | 'America/Port_of_Spain' | 'America/Porto_Velho' | 'America/Puerto_Rico' | 'America/Santo_Domingo' | 'America/Thule' | 'Atlantic/Bermuda' | 'America/St_Johns' | 'America/Araguaina' | 'America/Argentina/Buenos_Aires' | 'America/Bahia' | 'America/Belem' | 'America/Cayenne' | 'America/Fortaleza' | 'America/Godthab' | 'America/Maceio' | 'America/Miquelon' | 'America/Montevideo' | 'America/Paramaribo' | 'America/Recife' | 'America/Santiago' | 'America/Sao_Paulo' | 'Antarctica/Palmer' | 'Antarctica/Rothera' | 'Atlantic/Stanley' | 'America/Noronha' | 'Atlantic/South_Georgia' | 'America/Scoresbysund' | 'Atlantic/Azores' | 'Atlantic/Cape_Verde' | 'Africa/Abidjan' | 'Africa/Accra' | 'Africa/Bissau' | 'Africa/Casablanca' | 'Africa/El_Aaiun' | 'Africa/Monrovia' | 'America/Danmarkshavn' | 'Atlantic/Canary' | 'Atlantic/Faroe' | 'Atlantic/Reykjavik' | 'Etc/GMT' | 'Europe/Dublin' | 'Europe/Lisbon' | 'Europe/London' | 'Africa/Algiers' | 'Africa/Ceuta' | 'Africa/Lagos' | 'Africa/Ndjamena' | 'Africa/Tunis' | 'Africa/Windhoek' | 'Europe/Amsterdam' | 'Europe/Andorra' | 'Europe/Belgrade' | 'Europe/Berlin' | 'Europe/Brussels' | 'Europe/Budapest' | 'Europe/Copenhagen' | 'Europe/Gibraltar' | 'Europe/Ljubljana' | 'Europe/Luxembourg' | 'Europe/Madrid' | 'Europe/Malta' | 'Europe/Monaco' | 'Europe/Oslo' | 'Europe/Paris' | 'Europe/Prague' | 'Europe/Rome' | 'Europe/Stockholm' | 'Europe/Tirane' | 'Europe/Vienna' | 'Europe/Warsaw' | 'Europe/Zurich' | 'Africa/Cairo' | 'Africa/Johannesburg' | 'Africa/Maputo' | 'Africa/Tripoli' | 'Asia/Amman' | 'Asia/Beirut' | 'Asia/Damascus' | 'Asia/Gaza' | 'Asia/Jerusalem' | 'Asia/Nicosia' | 'Europe/Athens' | 'Europe/Bucharest' | 'Europe/Chisinau' | 'Europe/Helsinki' | 'Europe/Istanbul' | 'Europe/Kaliningrad' | 'Europe/Kyiv' | 'Europe/Riga' | 'Europe/Sofia' | 'Europe/Tallinn' | 'Europe/Vilnius' | 'Africa/Khartoum' | 'Africa/Nairobi' | 'Antarctica/Syowa' | 'Asia/Baghdad' | 'Asia/Qatar' | 'Asia/Riyadh' | 'Europe/Minsk' | 'Europe/Moscow' | 'Asia/Tehran' | 'Asia/Baku' | 'Asia/Dubai' | 'Asia/Tbilisi' | 'Asia/Yerevan' | 'Europe/Samara' | 'Indian/Mahe' | 'Indian/Mauritius' | 'Indian/Reunion' | 'Asia/Kabul' | 'Antarctica/Mawson' | 'Asia/Aqtau' | 'Asia/Aqtobe' | 'Asia/Ashgabat' | 'Asia/Dushanbe' | 'Asia/Karachi' | 'Asia/Tashkent' | 'Asia/Yekaterinburg' | 'Indian/Kerguelen' | 'Indian/Maldives' | 'Asia/Calcutta' | 'Asia/Colombo' | 'Asia/Katmandu' | 'Antarctica/Vostok' | 'Asia/Almaty' | 'Asia/Bishkek' | 'Asia/Dhaka' | 'Asia/Omsk' | 'Asia/Thimphu' | 'Indian/Chagos' | 'Asia/Rangoon' | 'Indian/Cocos' | 'Antarctica/Davis' | 'Asia/Bangkok' | 'Asia/Hovd' | 'Asia/Jakarta' | 'Asia/Krasnoyarsk' | 'Asia/Saigon' | 'Asia/Ho_Chi_Minh' | 'Indian/Christmas' | 'Antarctica/Casey' | 'Asia/Brunei' | 'Asia/Choibalsan' | 'Asia/Hong_Kong' | 'Asia/Irkutsk' | 'Asia/Kuala_Lumpur' | 'Asia/Macau' | 'Asia/Makassar' | 'Asia/Manila' | 'Asia/Shanghai' | 'Asia/Singapore' | 'Asia/Taipei' | 'Asia/Ulaanbaatar' | 'Australia/Perth' | 'Asia/Pyongyang' | 'Asia/Dili' | 'Asia/Jayapura' | 'Asia/Seoul' | 'Asia/Tokyo' | 'Asia/Yakutsk' | 'Pacific/Palau' | 'Australia/Adelaide' | 'Australia/Darwin' | 'Antarctica/DumontDUrville' | 'Asia/Magadan' | 'Asia/Vladivostok' | 'Australia/Brisbane' | 'Asia/Sakhalin' | 'Australia/Hobart' | 'Australia/Sydney' | 'Pacific/Chuuk' | 'Pacific/Guam' | 'Pacific/Port_Moresby' | 'Pacific/Efate' | 'Pacific/Guadalcanal' | 'Pacific/Kosrae' | 'Pacific/Norfolk' | 'Pacific/Noumea' | 'Pacific/Pohnpei' | 'Asia/Kamchatka' | 'Pacific/Auckland' | 'Pacific/Fiji' | 'Pacific/Funafuti' | 'Pacific/Kwajalein' | 'Pacific/Majuro' | 'Pacific/Nauru' | 'Pacific/Tarawa' | 'Pacific/Wake' | 'Pacific/Wallis' | 'Pacific/Apia' | 'Pacific/Enderbury' | 'Pacific/Fakaofo' | 'Pacific/Tongatapu' | 'Pacific/Kiritimati' | 'UTC';
    /**
     * Per-product freemium access flags (internal only)
     */
    freemiumProducts?: {
      pool?: {
        /**
         * Whether Pool freemium is enabled for this company
         */
        enabled?: boolean;
      };
    };
  }> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/api/serviceorganizations/processes/mcp/companies',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `default error response`,
        500: `default error response`,
      },
    });
  }

  /**
   * Get the authenticated user's company profile
   * @param requestBody
   * @returns any status success
   * @throws ApiError
   */
  public postApiServiceorganizationsProcessesCompaniesContext(
    requestBody?: {
      /**
       * Company UUID
       */
      companyUuid: string;
      /**
       * User UUID
       */
      userUuid: string;
    },
  ): CancelablePromise<{
    data?: {
      readonly uuid?: string;
      readonly createdAt?: string;
      readonly createdBy?: string;
      readonly lastUpdatedAt?: string;
      readonly lastUpdatedBy?: string;
      readonly lastUpdatedByAudience?: string;
      readonly lastUpdatedByAudienceUuid?: string;
      readonly lastUpdatedByImpersonatedBy?: string;
      readonly lastUpdatedByCompanyUuid?: string;
      readonly lastUpdatedByEnterpriseUuid?: string;
      name: string;
      slug?: string;
      mainLogoUrl?: string;
      mainWebsiteUrl?: string;
      privacyPolicyUrl?: string;
      termsOfServiceUrl?: string;
      defaultBrandUuid?: string;
      address?: {
        address1?: string;
        address2?: string;
        city?: string;
        zip?: string;
        state?: string;
        country?: string;
      };
      /**
       * whether the portal has been configured at least once
       */
      hasSetupPortal?: boolean;
      /**
       * Optional metadata object containing self-serve account information and other additional fields.
       */
      metadata?: Record<string, any>;
      legalName?: string;
      /**
       * Employer identification number
       */
      ein?: string;
      /**
       * when the hire account was connected
       */
      readonly hireConnectedAt?: string | null;
      /**
       * Account UUID in Fountain Hire
       */
      hireAccountUuid?: string;
      /**
       * Account base URL in Fountain Hire
       */
      hireAccountBaseUrl?: string;
      /**
       * Account base URL for Fountain Go
       */
      hireGoAccountBaseUrl?: string;
      /**
       * Account Career Site base URL in Fountain Hire
       */
      careerSiteUrl?: string;
      /**
       * Account API key in Fountain Hire
       */
      hireAccountApiKey?: string;
      /**
       * Account Recruiter Base URL in Fountain Hire
       */
      hireAccountRecruiterBaseUrl?: string;
      /**
       * Account slug in Fountain Hire
       */
      hireAccountSlug?: string;
      /**
       * Contact email for workers needing additional assistance
       */
      supportEmail?: string;
      /**
       * Contact phone number for workers needing additional assistance
       */
      supportPhone?: string;
      /**
       * Customer-facing support URL
       */
      supportUrl?: string;
      /**
       * Email of the authorized representative for SMS brand registration
       */
      contactEmail?: string;
      /**
       * Phone number of the authorized representative for SMS brand registration
       */
      contactPhone?: string;
      /**
       * Alternative phone numbers for workers according to their hiring source
       */
      alternativeSupportPhones?: Array<{
        number: string;
        source: string;
      }>;
      /**
       * Enables or disables employer messaging functionality for Hire applicants
       */
      hireMessagingEnabled?: boolean;
      /**
       * Enables or disables employer messaging functionality for Workday candidates
       */
      workdayMessagingEnabled?: boolean;
      /**
       * Enables or disables automated data synchronization with Fountain Hire
       */
      enableHireDataSync?: boolean;
      /**
       * This company has a Fountain Hire Go account
       */
      hasHireGoAccount?: boolean;
      /**
       * This company uses unified authentication system
       */
      unifiedAuth?: boolean;
      /**
       * This company uses unified access system
       */
      unifiedAccess?: boolean;
      /**
       * If true, all users in this company need 2fa enabled
       */
      tfaRequired?: boolean;
      /**
       * Number of days before a worker is considered inactive and locked out of the system
       */
      inactivityLockDays?: number;
      /**
       * Password policy for employers in the company
       */
      passwordPolicy?: {
        /**
         * Minimum length of the password
         */
        minLength?: number;
        /**
         * Number of days before the password expires
         */
        expireAfterDays?: number;
      };
      portalOptions?: {
        enableMagicLink?: boolean;
        enableOtp?: boolean;
        enableUpdateContactInfo?: {
          firstname?: boolean;
          lastname?: boolean;
          personalEmail?: boolean;
          mobilePhone?: boolean;
        };
        enableSmsOptOut?: boolean;
      };
      companyType?: 'active' | 'internal' | 'pilot' | 'demo';
      /**
       * Lifecycle status mirrored from the Hire account. Only settable via the internal process endpoint.
       */
      accountStatus?: 'live' | 'paused' | 'churned';
      /**
       * Contact first name for SMS brand registration
       */
      contactFirstName?: string;
      /**
       * Contact last name for SMS brand registration
       */
      contactLastName?: string;
      /**
       * Industry vertical for SMS brand registration
       */
      vertical?: 'AGRICULTURE' | 'COMMUNICATION' | 'CONSTRUCTION' | 'EDUCATION' | 'ENERGY' | 'ENTERTAINMENT' | 'FINANCIAL' | 'GAMBLING' | 'GOVERNMENT' | 'HEALTHCARE' | 'HOSPITALITY' | 'HUMAN_RESOURCES' | 'INSURANCE' | 'LEGAL' | 'MANUFACTURING' | 'NGO' | 'POLITICAL' | 'POSTAL' | 'PROFESSIONAL' | 'REAL_ESTATE' | 'RETAIL' | 'TECHNOLOGY' | 'TRANSPORTATION';
      /**
       * Salesforce ID for the company
       */
      salesforceId?: string;
      /**
       * Indicates if this company was created through self-serve registration
       */
      selfServe?: boolean;
      /**
       * Free-form context notes about the company.
       */
      companyContext?: string;
      /**
       * IANA timezone identifier for the company (e.g. "America/Chicago"). Used to determine business hours for outbound worker actions.
       */
      timezone?: 'Pacific/Niue' | 'Pacific/Pago_Pago' | 'Pacific/Honolulu' | 'Pacific/Rarotonga' | 'Pacific/Tahiti' | 'Pacific/Marquesas' | 'America/Anchorage' | 'Pacific/Gambier' | 'America/Los_Angeles' | 'America/Tijuana' | 'America/Vancouver' | 'America/Whitehorse' | 'Pacific/Pitcairn' | 'America/Dawson_Creek' | 'America/Denver' | 'America/Edmonton' | 'America/Hermosillo' | 'America/Mazatlan' | 'America/Phoenix' | 'America/Yellowknife' | 'America/Belize' | 'America/Chicago' | 'America/Costa_Rica' | 'America/El_Salvador' | 'America/Guatemala' | 'America/Managua' | 'America/Mexico_City' | 'America/Regina' | 'America/Tegucigalpa' | 'America/Winnipeg' | 'Pacific/Galapagos' | 'America/Bogota' | 'America/Cancun' | 'America/Cayman' | 'America/Guayaquil' | 'America/Havana' | 'America/Iqaluit' | 'America/Jamaica' | 'America/Lima' | 'America/Nassau' | 'America/New_York' | 'America/Panama' | 'America/Port-au-Prince' | 'America/Rio_Branco' | 'America/Toronto' | 'Pacific/Easter' | 'America/Caracas' | 'America/Asuncion' | 'America/Barbados' | 'America/Boa_Vista' | 'America/Campo_Grande' | 'America/Cuiaba' | 'America/Curacao' | 'America/Grand_Turk' | 'America/Guyana' | 'America/Halifax' | 'America/La_Paz' | 'America/Manaus' | 'America/Martinique' | 'America/Port_of_Spain' | 'America/Porto_Velho' | 'America/Puerto_Rico' | 'America/Santo_Domingo' | 'America/Thule' | 'Atlantic/Bermuda' | 'America/St_Johns' | 'America/Araguaina' | 'America/Argentina/Buenos_Aires' | 'America/Bahia' | 'America/Belem' | 'America/Cayenne' | 'America/Fortaleza' | 'America/Godthab' | 'America/Maceio' | 'America/Miquelon' | 'America/Montevideo' | 'America/Paramaribo' | 'America/Recife' | 'America/Santiago' | 'America/Sao_Paulo' | 'Antarctica/Palmer' | 'Antarctica/Rothera' | 'Atlantic/Stanley' | 'America/Noronha' | 'Atlantic/South_Georgia' | 'America/Scoresbysund' | 'Atlantic/Azores' | 'Atlantic/Cape_Verde' | 'Africa/Abidjan' | 'Africa/Accra' | 'Africa/Bissau' | 'Africa/Casablanca' | 'Africa/El_Aaiun' | 'Africa/Monrovia' | 'America/Danmarkshavn' | 'Atlantic/Canary' | 'Atlantic/Faroe' | 'Atlantic/Reykjavik' | 'Etc/GMT' | 'Europe/Dublin' | 'Europe/Lisbon' | 'Europe/London' | 'Africa/Algiers' | 'Africa/Ceuta' | 'Africa/Lagos' | 'Africa/Ndjamena' | 'Africa/Tunis' | 'Africa/Windhoek' | 'Europe/Amsterdam' | 'Europe/Andorra' | 'Europe/Belgrade' | 'Europe/Berlin' | 'Europe/Brussels' | 'Europe/Budapest' | 'Europe/Copenhagen' | 'Europe/Gibraltar' | 'Europe/Ljubljana' | 'Europe/Luxembourg' | 'Europe/Madrid' | 'Europe/Malta' | 'Europe/Monaco' | 'Europe/Oslo' | 'Europe/Paris' | 'Europe/Prague' | 'Europe/Rome' | 'Europe/Stockholm' | 'Europe/Tirane' | 'Europe/Vienna' | 'Europe/Warsaw' | 'Europe/Zurich' | 'Africa/Cairo' | 'Africa/Johannesburg' | 'Africa/Maputo' | 'Africa/Tripoli' | 'Asia/Amman' | 'Asia/Beirut' | 'Asia/Damascus' | 'Asia/Gaza' | 'Asia/Jerusalem' | 'Asia/Nicosia' | 'Europe/Athens' | 'Europe/Bucharest' | 'Europe/Chisinau' | 'Europe/Helsinki' | 'Europe/Istanbul' | 'Europe/Kaliningrad' | 'Europe/Kyiv' | 'Europe/Riga' | 'Europe/Sofia' | 'Europe/Tallinn' | 'Europe/Vilnius' | 'Africa/Khartoum' | 'Africa/Nairobi' | 'Antarctica/Syowa' | 'Asia/Baghdad' | 'Asia/Qatar' | 'Asia/Riyadh' | 'Europe/Minsk' | 'Europe/Moscow' | 'Asia/Tehran' | 'Asia/Baku' | 'Asia/Dubai' | 'Asia/Tbilisi' | 'Asia/Yerevan' | 'Europe/Samara' | 'Indian/Mahe' | 'Indian/Mauritius' | 'Indian/Reunion' | 'Asia/Kabul' | 'Antarctica/Mawson' | 'Asia/Aqtau' | 'Asia/Aqtobe' | 'Asia/Ashgabat' | 'Asia/Dushanbe' | 'Asia/Karachi' | 'Asia/Tashkent' | 'Asia/Yekaterinburg' | 'Indian/Kerguelen' | 'Indian/Maldives' | 'Asia/Calcutta' | 'Asia/Colombo' | 'Asia/Katmandu' | 'Antarctica/Vostok' | 'Asia/Almaty' | 'Asia/Bishkek' | 'Asia/Dhaka' | 'Asia/Omsk' | 'Asia/Thimphu' | 'Indian/Chagos' | 'Asia/Rangoon' | 'Indian/Cocos' | 'Antarctica/Davis' | 'Asia/Bangkok' | 'Asia/Hovd' | 'Asia/Jakarta' | 'Asia/Krasnoyarsk' | 'Asia/Saigon' | 'Asia/Ho_Chi_Minh' | 'Indian/Christmas' | 'Antarctica/Casey' | 'Asia/Brunei' | 'Asia/Choibalsan' | 'Asia/Hong_Kong' | 'Asia/Irkutsk' | 'Asia/Kuala_Lumpur' | 'Asia/Macau' | 'Asia/Makassar' | 'Asia/Manila' | 'Asia/Shanghai' | 'Asia/Singapore' | 'Asia/Taipei' | 'Asia/Ulaanbaatar' | 'Australia/Perth' | 'Asia/Pyongyang' | 'Asia/Dili' | 'Asia/Jayapura' | 'Asia/Seoul' | 'Asia/Tokyo' | 'Asia/Yakutsk' | 'Pacific/Palau' | 'Australia/Adelaide' | 'Australia/Darwin' | 'Antarctica/DumontDUrville' | 'Asia/Magadan' | 'Asia/Vladivostok' | 'Australia/Brisbane' | 'Asia/Sakhalin' | 'Australia/Hobart' | 'Australia/Sydney' | 'Pacific/Chuuk' | 'Pacific/Guam' | 'Pacific/Port_Moresby' | 'Pacific/Efate' | 'Pacific/Guadalcanal' | 'Pacific/Kosrae' | 'Pacific/Norfolk' | 'Pacific/Noumea' | 'Pacific/Pohnpei' | 'Asia/Kamchatka' | 'Pacific/Auckland' | 'Pacific/Fiji' | 'Pacific/Funafuti' | 'Pacific/Kwajalein' | 'Pacific/Majuro' | 'Pacific/Nauru' | 'Pacific/Tarawa' | 'Pacific/Wake' | 'Pacific/Wallis' | 'Pacific/Apia' | 'Pacific/Enderbury' | 'Pacific/Fakaofo' | 'Pacific/Tongatapu' | 'Pacific/Kiritimati' | 'UTC';
      /**
       * Per-product freemium access flags (internal only)
       */
      freemiumProducts?: {
        pool?: {
          /**
           * Whether Pool freemium is enabled for this company
           */
          enabled?: boolean;
        };
      };
    };
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/serviceorganizations/processes/companies/context',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Company not found`,
      },
    });
  }

  /**
   * add company to the provided enterprise
   * @param companyUuid company UUID
   * @param enterpriseUuid enterprise UUID to add to company
   * @returns any Enterprise successfully added to company
   * @throws ApiError
   */
  public postApiServiceorganizationsProcessesCompaniesAddToEnterprise(
    companyUuid: string,
    enterpriseUuid: string,
  ): CancelablePromise<{
    data?: {
      success?: boolean;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/serviceorganizations/processes/companies/{companyUuid}/addToEnterprise',
      path: {
        'companyUuid': companyUuid,
      },
      query: {
        'enterpriseUuid': enterpriseUuid,
      },
    });
  }

  /**
   * Retrieve settings for synchronization with Hire data
   * @returns any Company sychronization data successfully retrieved
   * @throws ApiError
   */
  public getApiServiceorganizationsProcessesCompaniesRetrieveHireCompanySyncSettings(): CancelablePromise<{
    companiesToSync?: Array<{
      data?: {
        hireAccountBaseUrl?: string;
        hireAccountApiKey?: string;
        uuid?: string;
      };
    }>;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/processes/companies/retrieveHireCompanySyncSettings',
    });
  }

  /**
   * Connect a company with a matching Hire account
   * @param requestBody
   * @returns any Company successfully connected with Hire
   * @throws ApiError
   */
  public postApiServiceorganizationsProcessesCompaniesConnectToHire(
    requestBody?: {
      hireAccountApiKey: string;
      hireAccountBaseUrl: string;
    },
  ): CancelablePromise<{
    data?: Record<string, any>;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/serviceorganizations/processes/companies/connectToHire',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Connect a company with a matching Hire account
   * @returns any Company successfully disconnected from Hire
   * @throws ApiError
   */
  public deleteApiServiceorganizationsProcessesCompaniesConnectToHire(): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/api/serviceorganizations/processes/companies/connectToHire',
    });
  }

  /**
   * Retrieve monolith servers url from constants
   * @returns any Monolith Servers data successfully retrieved
   * @throws ApiError
   */
  public getApiServiceorganizationsProcessesCompaniesMonolithServers(): CancelablePromise<{
    data?: Array<{
      name: string;
      baseUrl: string;
      type: string;
    }>;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/processes/companies/monolithServers',
    });
  }

  /**
   * Return non-sensitive data about the company that the worker can get access to
   * @param companyUuid company uuid
   * @returns any Return non-sensitive data about the company that the worker can get access to
   * @throws ApiError
   */
  public getApiServiceorganizationsProcessesCompaniesFiltered(
    companyUuid: string,
  ): CancelablePromise<{
    data?: {
      readonly uuid?: string;
      name?: string;
      legalName?: string;
      mainLogoUrl?: string;
      slug?: string;
      /**
       * Contact email for workers needing additional assistance
       */
      supportEmail?: string;
      /**
       * Contact phone number for workers needing additional assistance
       */
      supportPhone?: string;
      /**
       * Alternative phone numbers for workers according to their hiring source
       */
      alternativeSupportPhones?: Array<{
        number: string;
        source: string;
      }>;
      address?: {
        address1?: string;
        address2?: string;
        city?: string;
        zip?: string;
        state?: string;
        country?: string;
      };
      portalOptions?: {
        enableMagicLink?: boolean;
        enableOtp?: boolean;
        enableUpdateContactInfo?: {
          firstname?: boolean;
          lastname?: boolean;
          personalEmail?: boolean;
          mobilePhone?: boolean;
        };
        enableSmsOptOut?: boolean;
      };
      defaultBrandUuid?: string;
    };
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/processes/companies/{companyUuid}/filtered',
      path: {
        'companyUuid': companyUuid,
      },
    });
  }

  /**
   * Returns feature flag values for a given company
   * @returns any JSON:API success payload with LaunchDarkly feature flag values for the JWT company context
   * @throws ApiError
   */
  public getApiServiceorganizationsProcessesCompaniesFeatures(): CancelablePromise<{
    data: {
      /**
       * Map of feature flag keys to values (booleans, strings, etc.)
       */
      featureFlags: Record<string, any>;
    };
    /**
     * JSON:API response metadata
     */
    meta: Record<string, any>;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/processes/companies/features',
    });
  }

  /**
   * Update the password policy for a company
   * @param companyUuid Company UUID
   * @param requestBody
   * @returns any Password policy successfully updated
   * @throws ApiError
   */
  public putApiServiceorganizationsProcessesCompaniesPasswordPolicy(
    companyUuid: string,
    requestBody?: {
      /**
       * Minimum length for passwords
       */
      minLength: number;
      /**
       * Number of days after which passwords expire
       */
      expireAfterDays: number;
      /**
       * Number of days before a worker is considered inactive and locked out of the system
       */
      inactivityLockDays: number;
    },
  ): CancelablePromise<{
    success?: boolean;
  }> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/api/serviceorganizations/processes/companies/{companyUuid}/passwordPolicy',
      path: {
        'companyUuid': companyUuid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Mirror the Hire account lifecycle status onto the company (system-only)
   * @param companyUuid Company UUID
   * @param requestBody
   * @returns any Account status successfully updated
   * @throws ApiError
   */
  public patchApiServiceorganizationsProcessesCompaniesAccountStatus(
    companyUuid: string,
    requestBody: {
      accountStatus: 'live' | 'paused' | 'churned';
    },
  ): CancelablePromise<{
    data?: {
      uuid?: string;
      accountStatus?: 'live' | 'paused' | 'churned';
    };
  }> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/api/serviceorganizations/processes/companies/{companyUuid}/accountStatus',
      path: {
        'companyUuid': companyUuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `default error response`,
        403: `default error response`,
        404: `default error response`,
        500: `default error response`,
      },
    });
  }

  /**
   * Update an existing company's details
   * @param companyUuid company idenfitifer
   * @param requestBody
   * @returns any Successfully updated company
   * @throws ApiError
   */
  public patchApiServiceorganizationsProcessesMcpCompanies1(
    companyUuid: string,
    requestBody: {
      /**
       * Display name of the company.
       */
      name?: string;
      /**
       * Legal name of the company.
       */
      legalName?: string;
      /**
       * Type of company (active, internal, pilot, demo).
       */
      companyType?: 'active' | 'internal' | 'pilot' | 'demo';
      /**
       * Company address information.
       */
      address?: {
        /**
         * Primary address line.
         */
        address1?: string;
        /**
         * Secondary address line.
         */
        address2?: string;
        /**
         * City name.
         */
        city?: string;
        /**
         * ZIP or postal code.
         */
        zip?: string;
        /**
         * State or province name.
         */
        state?: string;
        /**
         * Country name.
         */
        country?: string;
      };
      /**
       * URL to the company logo.
       */
      mainLogoUrl?: string;
      /**
       * URL to the company website.
       */
      mainWebsiteUrl?: string;
      /**
       * URL to the company privacy policy page.
       */
      privacyPolicyUrl?: string;
      /**
       * URL to the company terms of service page.
       */
      termsOfServiceUrl?: string;
      /**
       * UUID of the default brand for the company.
       */
      defaultBrandUuid?: string;
      /**
       * URL to the company career site.
       */
      careerSiteUrl?: string;
      /**
       * Contact email for workers needing additional assistance.
       */
      supportEmail?: string;
      /**
       * Contact phone number for workers needing additional assistance.
       */
      supportPhone?: string;
      /**
       * Alternative phone numbers for workers according to their hiring source.
       */
      alternativeSupportPhones?: Array<{
        /**
         * Phone number.
         */
        number: string;
        /**
         * Source of the phone number.
         */
        source: string;
      }>;
      /**
       * Contact first name for SMS brand registration.
       */
      contactFirstName?: string;
      /**
       * Contact last name for SMS brand registration.
       */
      contactLastName?: string;
      /**
       * Industry vertical for SMS brand registration.
       */
      vertical?: 'AGRICULTURE' | 'COMMUNICATION' | 'CONSTRUCTION' | 'EDUCATION' | 'ENERGY' | 'ENTERTAINMENT' | 'FINANCIAL' | 'GAMBLING' | 'GOVERNMENT' | 'HEALTHCARE' | 'HOSPITALITY' | 'HUMAN_RESOURCES' | 'INSURANCE' | 'LEGAL' | 'MANUFACTURING' | 'NGO' | 'POLITICAL' | 'POSTAL' | 'PROFESSIONAL' | 'REAL_ESTATE' | 'RETAIL' | 'TECHNOLOGY' | 'TRANSPORTATION';
      /**
       * Preferred office timezone used for business-hours scheduling.
       */
      timezone?: 'Pacific/Niue' | 'Pacific/Pago_Pago' | 'Pacific/Honolulu' | 'Pacific/Rarotonga' | 'Pacific/Tahiti' | 'Pacific/Marquesas' | 'America/Anchorage' | 'Pacific/Gambier' | 'America/Los_Angeles' | 'America/Tijuana' | 'America/Vancouver' | 'America/Whitehorse' | 'Pacific/Pitcairn' | 'America/Dawson_Creek' | 'America/Denver' | 'America/Edmonton' | 'America/Hermosillo' | 'America/Mazatlan' | 'America/Phoenix' | 'America/Yellowknife' | 'America/Belize' | 'America/Chicago' | 'America/Costa_Rica' | 'America/El_Salvador' | 'America/Guatemala' | 'America/Managua' | 'America/Mexico_City' | 'America/Regina' | 'America/Tegucigalpa' | 'America/Winnipeg' | 'Pacific/Galapagos' | 'America/Bogota' | 'America/Cancun' | 'America/Cayman' | 'America/Guayaquil' | 'America/Havana' | 'America/Iqaluit' | 'America/Jamaica' | 'America/Lima' | 'America/Nassau' | 'America/New_York' | 'America/Panama' | 'America/Port-au-Prince' | 'America/Rio_Branco' | 'America/Toronto' | 'Pacific/Easter' | 'America/Caracas' | 'America/Asuncion' | 'America/Barbados' | 'America/Boa_Vista' | 'America/Campo_Grande' | 'America/Cuiaba' | 'America/Curacao' | 'America/Grand_Turk' | 'America/Guyana' | 'America/Halifax' | 'America/La_Paz' | 'America/Manaus' | 'America/Martinique' | 'America/Port_of_Spain' | 'America/Porto_Velho' | 'America/Puerto_Rico' | 'America/Santo_Domingo' | 'America/Thule' | 'Atlantic/Bermuda' | 'America/St_Johns' | 'America/Araguaina' | 'America/Argentina/Buenos_Aires' | 'America/Bahia' | 'America/Belem' | 'America/Cayenne' | 'America/Fortaleza' | 'America/Godthab' | 'America/Maceio' | 'America/Miquelon' | 'America/Montevideo' | 'America/Paramaribo' | 'America/Recife' | 'America/Santiago' | 'America/Sao_Paulo' | 'Antarctica/Palmer' | 'Antarctica/Rothera' | 'Atlantic/Stanley' | 'America/Noronha' | 'Atlantic/South_Georgia' | 'America/Scoresbysund' | 'Atlantic/Azores' | 'Atlantic/Cape_Verde' | 'Africa/Abidjan' | 'Africa/Accra' | 'Africa/Bissau' | 'Africa/Casablanca' | 'Africa/El_Aaiun' | 'Africa/Monrovia' | 'America/Danmarkshavn' | 'Atlantic/Canary' | 'Atlantic/Faroe' | 'Atlantic/Reykjavik' | 'Etc/GMT' | 'Europe/Dublin' | 'Europe/Lisbon' | 'Europe/London' | 'Africa/Algiers' | 'Africa/Ceuta' | 'Africa/Lagos' | 'Africa/Ndjamena' | 'Africa/Tunis' | 'Africa/Windhoek' | 'Europe/Amsterdam' | 'Europe/Andorra' | 'Europe/Belgrade' | 'Europe/Berlin' | 'Europe/Brussels' | 'Europe/Budapest' | 'Europe/Copenhagen' | 'Europe/Gibraltar' | 'Europe/Ljubljana' | 'Europe/Luxembourg' | 'Europe/Madrid' | 'Europe/Malta' | 'Europe/Monaco' | 'Europe/Oslo' | 'Europe/Paris' | 'Europe/Prague' | 'Europe/Rome' | 'Europe/Stockholm' | 'Europe/Tirane' | 'Europe/Vienna' | 'Europe/Warsaw' | 'Europe/Zurich' | 'Africa/Cairo' | 'Africa/Johannesburg' | 'Africa/Maputo' | 'Africa/Tripoli' | 'Asia/Amman' | 'Asia/Beirut' | 'Asia/Damascus' | 'Asia/Gaza' | 'Asia/Jerusalem' | 'Asia/Nicosia' | 'Europe/Athens' | 'Europe/Bucharest' | 'Europe/Chisinau' | 'Europe/Helsinki' | 'Europe/Istanbul' | 'Europe/Kaliningrad' | 'Europe/Kyiv' | 'Europe/Riga' | 'Europe/Sofia' | 'Europe/Tallinn' | 'Europe/Vilnius' | 'Africa/Khartoum' | 'Africa/Nairobi' | 'Antarctica/Syowa' | 'Asia/Baghdad' | 'Asia/Qatar' | 'Asia/Riyadh' | 'Europe/Minsk' | 'Europe/Moscow' | 'Asia/Tehran' | 'Asia/Baku' | 'Asia/Dubai' | 'Asia/Tbilisi' | 'Asia/Yerevan' | 'Europe/Samara' | 'Indian/Mahe' | 'Indian/Mauritius' | 'Indian/Reunion' | 'Asia/Kabul' | 'Antarctica/Mawson' | 'Asia/Aqtau' | 'Asia/Aqtobe' | 'Asia/Ashgabat' | 'Asia/Dushanbe' | 'Asia/Karachi' | 'Asia/Tashkent' | 'Asia/Yekaterinburg' | 'Indian/Kerguelen' | 'Indian/Maldives' | 'Asia/Calcutta' | 'Asia/Colombo' | 'Asia/Katmandu' | 'Antarctica/Vostok' | 'Asia/Almaty' | 'Asia/Bishkek' | 'Asia/Dhaka' | 'Asia/Omsk' | 'Asia/Thimphu' | 'Indian/Chagos' | 'Asia/Rangoon' | 'Indian/Cocos' | 'Antarctica/Davis' | 'Asia/Bangkok' | 'Asia/Hovd' | 'Asia/Jakarta' | 'Asia/Krasnoyarsk' | 'Asia/Saigon' | 'Asia/Ho_Chi_Minh' | 'Indian/Christmas' | 'Antarctica/Casey' | 'Asia/Brunei' | 'Asia/Choibalsan' | 'Asia/Hong_Kong' | 'Asia/Irkutsk' | 'Asia/Kuala_Lumpur' | 'Asia/Macau' | 'Asia/Makassar' | 'Asia/Manila' | 'Asia/Shanghai' | 'Asia/Singapore' | 'Asia/Taipei' | 'Asia/Ulaanbaatar' | 'Australia/Perth' | 'Asia/Pyongyang' | 'Asia/Dili' | 'Asia/Jayapura' | 'Asia/Seoul' | 'Asia/Tokyo' | 'Asia/Yakutsk' | 'Pacific/Palau' | 'Australia/Adelaide' | 'Australia/Darwin' | 'Antarctica/DumontDUrville' | 'Asia/Magadan' | 'Asia/Vladivostok' | 'Australia/Brisbane' | 'Asia/Sakhalin' | 'Australia/Hobart' | 'Australia/Sydney' | 'Pacific/Chuuk' | 'Pacific/Guam' | 'Pacific/Port_Moresby' | 'Pacific/Efate' | 'Pacific/Guadalcanal' | 'Pacific/Kosrae' | 'Pacific/Norfolk' | 'Pacific/Noumea' | 'Pacific/Pohnpei' | 'Asia/Kamchatka' | 'Pacific/Auckland' | 'Pacific/Fiji' | 'Pacific/Funafuti' | 'Pacific/Kwajalein' | 'Pacific/Majuro' | 'Pacific/Nauru' | 'Pacific/Tarawa' | 'Pacific/Wake' | 'Pacific/Wallis' | 'Pacific/Apia' | 'Pacific/Enderbury' | 'Pacific/Fakaofo' | 'Pacific/Tongatapu' | 'Pacific/Kiritimati' | 'UTC';
      /**
       * Arbitrary string key-value pairs for external system metadata. Maximum 50 keys.
       */
      externalMetadata?: Record<string, string>;
    },
  ): CancelablePromise<{
    readonly uuid?: string;
    readonly createdAt?: string;
    readonly createdBy?: string;
    readonly lastUpdatedAt?: string;
    readonly lastUpdatedBy?: string;
    readonly lastUpdatedByAudience?: string;
    readonly lastUpdatedByAudienceUuid?: string;
    readonly lastUpdatedByImpersonatedBy?: string;
    readonly lastUpdatedByCompanyUuid?: string;
    readonly lastUpdatedByEnterpriseUuid?: string;
    name: string;
    slug?: string;
    mainLogoUrl?: string;
    mainWebsiteUrl?: string;
    privacyPolicyUrl?: string;
    termsOfServiceUrl?: string;
    defaultBrandUuid?: string;
    address?: {
      address1?: string;
      address2?: string;
      city?: string;
      zip?: string;
      state?: string;
      country?: string;
    };
    /**
     * whether the portal has been configured at least once
     */
    hasSetupPortal?: boolean;
    /**
     * Optional metadata object containing self-serve account information and other additional fields.
     */
    metadata?: Record<string, any>;
    legalName?: string;
    /**
     * Employer identification number
     */
    ein?: string;
    /**
     * when the hire account was connected
     */
    readonly hireConnectedAt?: string | null;
    /**
     * Account UUID in Fountain Hire
     */
    hireAccountUuid?: string;
    /**
     * Account base URL in Fountain Hire
     */
    hireAccountBaseUrl?: string;
    /**
     * Account base URL for Fountain Go
     */
    hireGoAccountBaseUrl?: string;
    /**
     * Account Career Site base URL in Fountain Hire
     */
    careerSiteUrl?: string;
    /**
     * Account API key in Fountain Hire
     */
    hireAccountApiKey?: string;
    /**
     * Account Recruiter Base URL in Fountain Hire
     */
    hireAccountRecruiterBaseUrl?: string;
    /**
     * Account slug in Fountain Hire
     */
    hireAccountSlug?: string;
    /**
     * Contact email for workers needing additional assistance
     */
    supportEmail?: string;
    /**
     * Contact phone number for workers needing additional assistance
     */
    supportPhone?: string;
    /**
     * Customer-facing support URL
     */
    supportUrl?: string;
    /**
     * Email of the authorized representative for SMS brand registration
     */
    contactEmail?: string;
    /**
     * Phone number of the authorized representative for SMS brand registration
     */
    contactPhone?: string;
    /**
     * Alternative phone numbers for workers according to their hiring source
     */
    alternativeSupportPhones?: Array<{
      number: string;
      source: string;
    }>;
    /**
     * Enables or disables employer messaging functionality for Hire applicants
     */
    hireMessagingEnabled?: boolean;
    /**
     * Enables or disables employer messaging functionality for Workday candidates
     */
    workdayMessagingEnabled?: boolean;
    /**
     * Enables or disables automated data synchronization with Fountain Hire
     */
    enableHireDataSync?: boolean;
    /**
     * This company has a Fountain Hire Go account
     */
    hasHireGoAccount?: boolean;
    /**
     * This company uses unified authentication system
     */
    unifiedAuth?: boolean;
    /**
     * This company uses unified access system
     */
    unifiedAccess?: boolean;
    /**
     * If true, all users in this company need 2fa enabled
     */
    tfaRequired?: boolean;
    /**
     * Number of days before a worker is considered inactive and locked out of the system
     */
    inactivityLockDays?: number;
    /**
     * Password policy for employers in the company
     */
    passwordPolicy?: {
      /**
       * Minimum length of the password
       */
      minLength?: number;
      /**
       * Number of days before the password expires
       */
      expireAfterDays?: number;
    };
    portalOptions?: {
      enableMagicLink?: boolean;
      enableOtp?: boolean;
      enableUpdateContactInfo?: {
        firstname?: boolean;
        lastname?: boolean;
        personalEmail?: boolean;
        mobilePhone?: boolean;
      };
      enableSmsOptOut?: boolean;
    };
    companyType?: 'active' | 'internal' | 'pilot' | 'demo';
    /**
     * Lifecycle status mirrored from the Hire account. Only settable via the internal process endpoint.
     */
    accountStatus?: 'live' | 'paused' | 'churned';
    /**
     * Contact first name for SMS brand registration
     */
    contactFirstName?: string;
    /**
     * Contact last name for SMS brand registration
     */
    contactLastName?: string;
    /**
     * Industry vertical for SMS brand registration
     */
    vertical?: 'AGRICULTURE' | 'COMMUNICATION' | 'CONSTRUCTION' | 'EDUCATION' | 'ENERGY' | 'ENTERTAINMENT' | 'FINANCIAL' | 'GAMBLING' | 'GOVERNMENT' | 'HEALTHCARE' | 'HOSPITALITY' | 'HUMAN_RESOURCES' | 'INSURANCE' | 'LEGAL' | 'MANUFACTURING' | 'NGO' | 'POLITICAL' | 'POSTAL' | 'PROFESSIONAL' | 'REAL_ESTATE' | 'RETAIL' | 'TECHNOLOGY' | 'TRANSPORTATION';
    /**
     * Salesforce ID for the company
     */
    salesforceId?: string;
    /**
     * Indicates if this company was created through self-serve registration
     */
    selfServe?: boolean;
    /**
     * Free-form context notes about the company.
     */
    companyContext?: string;
    /**
     * IANA timezone identifier for the company (e.g. "America/Chicago"). Used to determine business hours for outbound worker actions.
     */
    timezone?: 'Pacific/Niue' | 'Pacific/Pago_Pago' | 'Pacific/Honolulu' | 'Pacific/Rarotonga' | 'Pacific/Tahiti' | 'Pacific/Marquesas' | 'America/Anchorage' | 'Pacific/Gambier' | 'America/Los_Angeles' | 'America/Tijuana' | 'America/Vancouver' | 'America/Whitehorse' | 'Pacific/Pitcairn' | 'America/Dawson_Creek' | 'America/Denver' | 'America/Edmonton' | 'America/Hermosillo' | 'America/Mazatlan' | 'America/Phoenix' | 'America/Yellowknife' | 'America/Belize' | 'America/Chicago' | 'America/Costa_Rica' | 'America/El_Salvador' | 'America/Guatemala' | 'America/Managua' | 'America/Mexico_City' | 'America/Regina' | 'America/Tegucigalpa' | 'America/Winnipeg' | 'Pacific/Galapagos' | 'America/Bogota' | 'America/Cancun' | 'America/Cayman' | 'America/Guayaquil' | 'America/Havana' | 'America/Iqaluit' | 'America/Jamaica' | 'America/Lima' | 'America/Nassau' | 'America/New_York' | 'America/Panama' | 'America/Port-au-Prince' | 'America/Rio_Branco' | 'America/Toronto' | 'Pacific/Easter' | 'America/Caracas' | 'America/Asuncion' | 'America/Barbados' | 'America/Boa_Vista' | 'America/Campo_Grande' | 'America/Cuiaba' | 'America/Curacao' | 'America/Grand_Turk' | 'America/Guyana' | 'America/Halifax' | 'America/La_Paz' | 'America/Manaus' | 'America/Martinique' | 'America/Port_of_Spain' | 'America/Porto_Velho' | 'America/Puerto_Rico' | 'America/Santo_Domingo' | 'America/Thule' | 'Atlantic/Bermuda' | 'America/St_Johns' | 'America/Araguaina' | 'America/Argentina/Buenos_Aires' | 'America/Bahia' | 'America/Belem' | 'America/Cayenne' | 'America/Fortaleza' | 'America/Godthab' | 'America/Maceio' | 'America/Miquelon' | 'America/Montevideo' | 'America/Paramaribo' | 'America/Recife' | 'America/Santiago' | 'America/Sao_Paulo' | 'Antarctica/Palmer' | 'Antarctica/Rothera' | 'Atlantic/Stanley' | 'America/Noronha' | 'Atlantic/South_Georgia' | 'America/Scoresbysund' | 'Atlantic/Azores' | 'Atlantic/Cape_Verde' | 'Africa/Abidjan' | 'Africa/Accra' | 'Africa/Bissau' | 'Africa/Casablanca' | 'Africa/El_Aaiun' | 'Africa/Monrovia' | 'America/Danmarkshavn' | 'Atlantic/Canary' | 'Atlantic/Faroe' | 'Atlantic/Reykjavik' | 'Etc/GMT' | 'Europe/Dublin' | 'Europe/Lisbon' | 'Europe/London' | 'Africa/Algiers' | 'Africa/Ceuta' | 'Africa/Lagos' | 'Africa/Ndjamena' | 'Africa/Tunis' | 'Africa/Windhoek' | 'Europe/Amsterdam' | 'Europe/Andorra' | 'Europe/Belgrade' | 'Europe/Berlin' | 'Europe/Brussels' | 'Europe/Budapest' | 'Europe/Copenhagen' | 'Europe/Gibraltar' | 'Europe/Ljubljana' | 'Europe/Luxembourg' | 'Europe/Madrid' | 'Europe/Malta' | 'Europe/Monaco' | 'Europe/Oslo' | 'Europe/Paris' | 'Europe/Prague' | 'Europe/Rome' | 'Europe/Stockholm' | 'Europe/Tirane' | 'Europe/Vienna' | 'Europe/Warsaw' | 'Europe/Zurich' | 'Africa/Cairo' | 'Africa/Johannesburg' | 'Africa/Maputo' | 'Africa/Tripoli' | 'Asia/Amman' | 'Asia/Beirut' | 'Asia/Damascus' | 'Asia/Gaza' | 'Asia/Jerusalem' | 'Asia/Nicosia' | 'Europe/Athens' | 'Europe/Bucharest' | 'Europe/Chisinau' | 'Europe/Helsinki' | 'Europe/Istanbul' | 'Europe/Kaliningrad' | 'Europe/Kyiv' | 'Europe/Riga' | 'Europe/Sofia' | 'Europe/Tallinn' | 'Europe/Vilnius' | 'Africa/Khartoum' | 'Africa/Nairobi' | 'Antarctica/Syowa' | 'Asia/Baghdad' | 'Asia/Qatar' | 'Asia/Riyadh' | 'Europe/Minsk' | 'Europe/Moscow' | 'Asia/Tehran' | 'Asia/Baku' | 'Asia/Dubai' | 'Asia/Tbilisi' | 'Asia/Yerevan' | 'Europe/Samara' | 'Indian/Mahe' | 'Indian/Mauritius' | 'Indian/Reunion' | 'Asia/Kabul' | 'Antarctica/Mawson' | 'Asia/Aqtau' | 'Asia/Aqtobe' | 'Asia/Ashgabat' | 'Asia/Dushanbe' | 'Asia/Karachi' | 'Asia/Tashkent' | 'Asia/Yekaterinburg' | 'Indian/Kerguelen' | 'Indian/Maldives' | 'Asia/Calcutta' | 'Asia/Colombo' | 'Asia/Katmandu' | 'Antarctica/Vostok' | 'Asia/Almaty' | 'Asia/Bishkek' | 'Asia/Dhaka' | 'Asia/Omsk' | 'Asia/Thimphu' | 'Indian/Chagos' | 'Asia/Rangoon' | 'Indian/Cocos' | 'Antarctica/Davis' | 'Asia/Bangkok' | 'Asia/Hovd' | 'Asia/Jakarta' | 'Asia/Krasnoyarsk' | 'Asia/Saigon' | 'Asia/Ho_Chi_Minh' | 'Indian/Christmas' | 'Antarctica/Casey' | 'Asia/Brunei' | 'Asia/Choibalsan' | 'Asia/Hong_Kong' | 'Asia/Irkutsk' | 'Asia/Kuala_Lumpur' | 'Asia/Macau' | 'Asia/Makassar' | 'Asia/Manila' | 'Asia/Shanghai' | 'Asia/Singapore' | 'Asia/Taipei' | 'Asia/Ulaanbaatar' | 'Australia/Perth' | 'Asia/Pyongyang' | 'Asia/Dili' | 'Asia/Jayapura' | 'Asia/Seoul' | 'Asia/Tokyo' | 'Asia/Yakutsk' | 'Pacific/Palau' | 'Australia/Adelaide' | 'Australia/Darwin' | 'Antarctica/DumontDUrville' | 'Asia/Magadan' | 'Asia/Vladivostok' | 'Australia/Brisbane' | 'Asia/Sakhalin' | 'Australia/Hobart' | 'Australia/Sydney' | 'Pacific/Chuuk' | 'Pacific/Guam' | 'Pacific/Port_Moresby' | 'Pacific/Efate' | 'Pacific/Guadalcanal' | 'Pacific/Kosrae' | 'Pacific/Norfolk' | 'Pacific/Noumea' | 'Pacific/Pohnpei' | 'Asia/Kamchatka' | 'Pacific/Auckland' | 'Pacific/Fiji' | 'Pacific/Funafuti' | 'Pacific/Kwajalein' | 'Pacific/Majuro' | 'Pacific/Nauru' | 'Pacific/Tarawa' | 'Pacific/Wake' | 'Pacific/Wallis' | 'Pacific/Apia' | 'Pacific/Enderbury' | 'Pacific/Fakaofo' | 'Pacific/Tongatapu' | 'Pacific/Kiritimati' | 'UTC';
    /**
     * Per-product freemium access flags (internal only)
     */
    freemiumProducts?: {
      pool?: {
        /**
         * Whether Pool freemium is enabled for this company
         */
        enabled?: boolean;
      };
    };
  }> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/api/serviceorganizations/processes/mcp/companies/{companyUuid}',
      path: {
        'companyUuid': companyUuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * Refresh the Salesforce ID for a company
   * @returns void
   * @throws ApiError
   */
  public postApiServiceorganizationsProcessRefreshSalesforceId(): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/serviceorganizations/process/refreshSalesforceId',
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * Get the Salesforce info for the caller company
   * Retrieves Salesforce account information for the company associated with the authenticated user
   * @param refreshCache If true, bypasses the cache and fetches fresh data from Salesforce. Use this only if you know the data is outdated or stale.
   * @returns any Salesforce info retrieved successfully
   * @throws ApiError
   */
  public getApiServiceorganizationsProcessCompaniesSalesforce(
    refreshCache?: boolean,
  ): CancelablePromise<{
    /**
     * Salesforce account record. Fields vary by account configuration.
     */
    data?: Record<string, any>;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/process/companies/salesforce',
      query: {
        'refreshCache': refreshCache,
      },
      errors: {
        403: `default error response`,
        404: `default error response`,
        500: `default error response`,
      },
    });
  }

  /**
   * Submit SMS brand registration for a company
   * @param companyUuid UUID of the company to register
   * @param requestBody
   * @returns any SMS registration submitted successfully
   * @throws ApiError
   */
  public postApiServiceorganizationsProcessesCompaniesSmsRegistration(
    companyUuid: string,
    requestBody: {
      /**
       * Industry vertical for SMS brand registration.
       */
      vertical: 'AGRICULTURE' | 'COMMUNICATION' | 'CONSTRUCTION' | 'EDUCATION' | 'ENERGY' | 'ENTERTAINMENT' | 'FINANCIAL' | 'GAMBLING' | 'GOVERNMENT' | 'HEALTHCARE' | 'HOSPITALITY' | 'HUMAN_RESOURCES' | 'INSURANCE' | 'LEGAL' | 'MANUFACTURING' | 'NGO' | 'POLITICAL' | 'POSTAL' | 'PROFESSIONAL' | 'REAL_ESTATE' | 'RETAIL' | 'TECHNOLOGY' | 'TRANSPORTATION';
      /**
       * Employer Identification Number (format XX-XXXXXXX). Ignored when a default EIN already exists for the company.
       */
      ein: string;
      /**
       * Legal business name registered with the IRS. Used as the EIN label.
       */
      einLabel: string;
      /**
       * Company address.
       */
      address: {
        /**
         * Primary address line.
         */
        address1: string;
        /**
         * Secondary address line.
         */
        address2?: string;
        /**
         * City name.
         */
        city: string;
        /**
         * State or province.
         */
        state: string;
        /**
         * ZIP or postal code.
         */
        zip: string;
        /**
         * Country.
         */
        country: string;
      };
      /**
       * Company website URL with protocol. Send null/omit to use the Fountain-hosted page; Hire fills in the canonical URL when blank.
       */
      mainWebsiteUrl?: string | null;
      /**
       * URL to the company privacy policy page. Send null/omit to use the Fountain-hosted page; Hire fills in the canonical URL when blank.
       */
      privacyPolicyUrl?: string | null;
      /**
       * URL to the company terms of service page. Send null/omit to use the Fountain-hosted page; Hire fills in the canonical URL when blank.
       */
      termsOfServiceUrl?: string | null;
      /**
       * Email of the authorized representative submitting this registration.
       */
      contactEmail: string;
      /**
       * Last name of the authorized representative for SMS registration.
       */
      contactLastName: string;
      /**
       * First name of the authorized representative for SMS registration.
       */
      contactFirstName: string;
      /**
       * Phone number of the authorized representative submitting this registration.
       */
      contactPhone: string;
      /**
       * A URL for support resources
       */
      contactUsUrl?: string | null;
      /**
       * Customer-facing support email
       */
      customerSupportEmail?: string | null;
      /**
       * Customer-facing support phone
       */
      customerSupportPhone?: string | null;
    },
  ): CancelablePromise<{
    data?: {
      companyUuid?: string;
    };
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/serviceorganizations/processes/companies/{companyUuid}/smsRegistration',
      path: {
        'companyUuid': companyUuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `default error response`,
        404: `default error response`,
        500: `default error response`,
      },
    });
  }

  /**
   * Sync the Hire API key after rotation so WX automations use the current key
   * @param companyUuid WX Company UUID
   * @param requestBody
   * @returns any Hire API key successfully synced
   * @throws ApiError
   */
  public patchApiServiceorganizationsProcessesCompaniesSyncHireApiKey(
    companyUuid: string,
    requestBody: {
      /**
       * The new Hire API key after rotation
       */
      hireAccountApiKey: string;
    },
  ): CancelablePromise<{
    data?: {
      uuid?: string;
      synced?: boolean;
    };
  }> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/api/serviceorganizations/processes/companies/{companyUuid}/syncHireApiKey',
      path: {
        'companyUuid': companyUuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `default error response`,
        404: `default error response`,
        500: `default error response`,
      },
    });
  }

}
